import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Home, Business, Group, Star } from '@mui/icons-material';

const OurStoryPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', py: 4 }}>
      <Container maxWidth="lg">
        {/* Breadcrumbs */}
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link component={RouterLink} to="/" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
            <Home sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          <Typography color="text.primary">Our Story</Typography>
        </Breadcrumbs>

        {/* Header */}
        <Paper elevation={0} sx={{ p: 4, mb: 4, textAlign: 'center', bgcolor: 'primary.main', color: 'white' }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Our Story
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9 }}>
            Building dreams with premium stones and exceptional service
          </Typography>
        </Paper>

        {/* Main Content */}
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Paper elevation={1} sx={{ p: 4 }}>
              <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
                Welcome to Mall of Stones
              </Typography>
              
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                Mall of Stones began with a simple vision: to make premium quality stones accessible to everyone. 
                Founded by passionate professionals in the stone industry, we recognized the need for a reliable 
                platform that connects customers with the finest marble, granite, and natural stones.
              </Typography>

              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                What started as a small venture has grown into a trusted marketplace where quality meets convenience. 
                We work directly with quarries and manufacturers to ensure our customers receive authentic, 
                high-grade stones at competitive prices.
              </Typography>

              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                Today, Mall of Stones serves customers across the country, helping them transform their spaces 
                with beautiful, durable stones. Whether you're an architect, contractor, or homeowner, 
                we're here to support your vision with our expertise and premium products.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Card elevation={1}>
                  <CardContent sx={{ textAlign: 'center', p: 3 }}>
                    <Business sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h6" gutterBottom>
                      Our Mission
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      To provide premium quality stones with exceptional service and competitive pricing.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card elevation={1}>
                  <CardContent sx={{ textAlign: 'center', p: 3 }}>
                    <Group sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h6" gutterBottom>
                      Our Team
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Experienced professionals dedicated to helping you find the perfect stones for your project.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card elevation={1}>
                  <CardContent sx={{ textAlign: 'center', p: 3 }}>
                    <Star sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h6" gutterBottom>
                      Our Promise
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Quality assurance, timely delivery, and customer satisfaction in every transaction.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default OurStoryPage;